"use client";

import { type Dispatch, type SetStateAction, createContext, useContext } from "react";
import type { FreshdeskTag } from "../..";

declare global {
	interface Window {
		fcWidget?: {
			isLoaded: () => boolean;
			init: (config: unknown) => Promise<void>;
			isOpen: () => boolean;
			open: () => void;
			close: () => void;
			// biome-ignore lint/suspicious/noExplicitAny: any is used to avoid type errors
			on: (event: string, callback: (data: any) => void) => void;
			user: {
				setProperties: (properties: unknown) => void;
			};
			setTags: (tags: string | string[]) => void;
		};
	}
}

interface ServiceContextValue {
	chatAvailable: boolean;

	isLoading: boolean;
	chatActive: boolean;
	unreadCount: number;

	onOpenHandler: (open?: boolean) => void;
	chatHandler: () => Promise<void>;
	tags: FreshdeskTag[];
	setTags: Dispatch<SetStateAction<FreshdeskTag[]>>;
}

export const ServiceContext = createContext({} as ServiceContextValue);

export const useServiceContext = () => {
	const context = useContext(ServiceContext);

	if (!context) {
		throw new Error("ServiceContext must be used within a ServiceContextProvider");
	}

	return context;
};
